import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter, SendDataToApi } from "@insite/client-framework/Store/Pages/OrderStatus/Handlers/Reorder";
import { CartLineCollectionModel, CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import { dispatchAddToCartEvent } from "@store/Services/AnalyticsService";

replaceInChain(chain, PopulateApiParameter, props => {
    const order = props.getState().pages.orderStatus.order;
    if (!order) {
        throw new Error("Reorder was called but there was no order available");
    }

    props.apiParameter = {
        cartLines: order.orderLines!.map(
            (line: OrderLineModel) =>
                ({
                    shortDescription: line.shortDescription, // Poolcorp Custom Code
                    productId: line.productId,
                    qtyOrdered: line.qtyOrdered ? line.qtyOrdered : line.qtyShipped + line.properties?.backorderQty, // Poolcorp Custom Code
                    unitOfMeasure: line.unitOfMeasure,
                } as CartLineModel),
        ),
    } as CartLineCollectionModel;
});

addToChainAfter(chain, SendDataToApi, props => {
    const state = props.getState();
    const currentCurency = state.context.session.currency?.currencyCode;
    if (props.apiParameter.cartLines) {
        dispatchAddToCartEvent(props.apiParameter.cartLines, currentCurency);
    }
});
